export const colors = {
  green: 'hsl(126, 41%, 59%)',
  blue: 'hsl(227, 85%, 59%)',
  orange: 'hsl(36, 90%, 51%)',
}
